<script>
    import { headerMobileMixin } from "@/mixins/header-mobile";
    import HeaderBurger from "@/components/header/HeaderBurger";
    import TheLogo from "@/components/TheLogo";
    import HeaderCart from "@zavtra/components/HeaderCart";
    import TheHeaderMobileMenu from "@zavtra/components/TheHeaderMobileMenu";

    export default {
        name: "TheHeaderMobile",
        components: {
            HeaderBurger,
            HeaderCart,
            TheHeaderMobileMenu,
            TheLogo,
        },
        props: {
            topMenu: Array,
            centerMenu: Array,
            isOrderPage: Boolean,
            cart: Object,
            freeDeliveryCount: Number,
            city: String,
            phoneCallCenter: String,
            isTopBanner: Boolean,
        },
        mixins: [headerMobileMixin],
    };
</script>

<template>
    <div class="the-header-mobile" ref="scrollHeader">
        <div class="the-header-mobile__wrapper js-mobile-header" data-fix-on-scroll>
            <div class="l-container">
                <div class="the-header-mobile__scroll">
                    <div class="the-header-mobile__burger" @click="openMobileMenu">
                        <header-burger :state="showMobileMenu"></header-burger>
                    </div>

                    <div class="the-header-mobile__logo-wrapper">
                        <the-logo></the-logo>
                    </div>

                    <header-cart
                        :cart="cart"
                        :free-delivery-count="freeDeliveryCount"
                        :is-order-page="isOrderPage"
                    ></header-cart>
                </div>
            </div>
        </div>

        <div class="the-header-mobile__menu" :class="{ 'is-opened': showMobileMenu }">
            <the-header-mobile-menu
                :center-menu="centerMenu"
                :top-menu="topMenu"
                :city="city"
                :phone-call-center="phoneCallCenter"
                @on-click="onClickAnchor"
            ></the-header-mobile-menu>
        </div>
    </div>
</template>

<style lang="scss">
    .the-header-mobile {
        @include sticky();
        z-index: 2050;
        @include bp($bp-desktop-sm) {
            display: none;
        }
    }

    .the-header-mobile__wrapper {
        position: relative;
        z-index: 49;
        left: 0;
        width: 100%;
        background-color: #fff;
        &::after {
            content: "";
            position: absolute;
            bottom: 0;
            left: 0;
            right: 0;
            height: 1px;
            background-color: var(--primary-border--dark);
        }
    }

    .the-header-mobile__scroll {
        display: flex;
        align-items: center;
        justify-content: space-between;
    }

    .the-header-mobile__burger {
        display: flex;
        justify-content: center;
        align-items: center;
        @include box(46px);
        margin-left: -12px;
    }

    .the-header-mobile__logo-wrapper {
        width: 200px;
    }

    .the-header-mobile__menu {
        position: fixed;
        top: 46px;
        left: 0;
        width: 100%;
        height: calc(100vh - 46px);
        height: calc((var(--vh, 1vh) * 100) - 46px);
        background-color: var(--service-background-color);
        z-index: 40;
        overflow: auto;
        transform: translateY(-112%);
        transition: 0.3s ease-in-out transform;
        &.is-opened {
            transform: translateY(0);
        }
    }
</style>
